import { render } from "./OpportunityCommentCreate.vue?vue&type=template&id=dc1a5eb6"
import script from "./OpportunityCommentCreate.vue?vue&type=script&lang=js"
export * from "./OpportunityCommentCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__